const style = {
  span: {
    display: `block`,
    fontSize: `13px`
  },
  headerSpan: {
    fontSize: `12px`
  },
  spanCenter: {
    textAlign: `center`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/RevenueTable/style/item.js